import LoaderComponent from '../../../assets/animations/Loader';
import React from 'react';
import './Loader.scss';


const Loader = ({width, height, color}) => {
    return (
        <div className="loader-container">
            {color ?
                <LoaderComponent width={width || '100px'} height={height || '100px'} color={color}/> :
                <LoaderComponent width={width || '100px'} height={height || '100px'} />
            }
        </div>
    );
};

export default Loader;
